import { getCurrentUser } from 'modules/Auth/currentUserUtil';

import { getAuthData } from './request-auth-data';

export const getCurrentBusinessId = (): string | undefined => {
  const currentUser = getCurrentUser();
  const { businessId } = getAuthData();
  return businessId || currentUser?.businessId;
};
